import ReleaseOne from "../mockData/images/releases/1lg.jpg"
import ReleaseTwo from "../mockData/images/releases/2lg.jpg"
import ReleaseThree from "../mockData/images/releases/3lg.jpg"
import ReleaseFour from "../mockData/images/releases/4lg.jpg"
import ReleaseFive from "../mockData/images/releases/5lg.jpg"

const mockReleaseDetailsData = [
    {
        "id": 1,
        "name": "Echoing Silhouette",
        "release_version": "",
        "language": "EN",
        "auto_detect_language": true,
        "label": {
            "id": 1,
            "name": "Solamente"
        },
        "artists": [
            {
                "id": 1624,
                "order": 0,
                "artist": {
                    "id": 4,
                    "name": "Gideon Bass"
                },
                "kind": "main"
            },
        ],
        "publisher": "Bassline Bridge Studios",
        "status": "distributed",
        "publisher_year": "2022",
        "copyright_holder": "Bassline Bridge Studios",
        "copyright_holder_year": "2022",
        "genre": 8,
        "subgenre": 246,
        "kind": "single",
        "catalogue_number": "IFO942591",
        "notes": "",
        "artwork": ReleaseOne,
        "is_new_release": 0,
        "official_date": "2022-04-25",
        "original_date": "2022-04-25",
        "exclusive_shop": null,
        "territory": "worldwide",
        "countries": [],
        "backcatalog": true,
        "ean": "42748034501",
        "generate_ean": false,
        "tracks": [
            {
                "id": 1692,
                "order": 0,
                "name": "Celestial Voyage",
                "artists": [
                    {
                        "id": 2534,
                        "order": 0,
                        "artist": 4,
                        "kind": "main"
                    },
                    {
                        "id": 2535,
                        "order": 1,
                        "artist": 181,
                        "kind": "featuring"
                    }
                ],
                "ISRC": "DEUD42301692",
                "generate_isrc": true,
                "genre": 8,
                "subgenre": 246,
                "mix_name": "",
                "resource": "",
                "mp3_resource": "",
                "album_only": false,
                "explicit_content": false,
                "track_lenght": "00:00:56",
                "track_data_complete": true,
                "track_ready_for_accounting": false,
                "track_accounting_data_editable": true,
                "spotify_id": null,
                "deezer_id": null,
                "qc_passed": true,
                "qc_feedback": {},
                "edited_after_qc": false
            }
        ],
        "all_tracks_ready": true,
        "sub_user": null,
        "release_date_passed": true,
        "has_delivery_confirmations": false,
        "transferred": false,
        "qc_passed": true,
        "qc_feedback": {},
        "edited_after_qc": false
    },
    {
        "id": 2,
        "name": "Serene Legacy",
        "release_version": "Remix",
        "language": "EN",
        "auto_detect_language": true,
        "label": {
            "id": 50,
            "name": "NoFace Records"
        },
        "artists": [
            {
                "id": 1620,
                "order": 0,
                "artist": {
                    "id": 346,
                    "name": "Silas Echo"
                },
                "kind": "main"
            }
        ],
        "publisher": "Bassline Bridge Studios",
        "status": "distributed",
        "publisher_year": "2023",
        "copyright_holder": "Bassline Bridge Studios",
        "copyright_holder_year": "2023",
        "genre": 8,
        "subgenre": 165,
        "kind": "single",
        "catalogue_number": "RMT816746",
        "notes": "",
        "artwork": ReleaseTwo,
        "is_new_release": 0,
        "official_date": "2023-10-27",
        "original_date": "2023-10-27",
        "exclusive_shop": null,
        "territory": "worldwide",
        "countries": [],
        "backcatalog": true,
        "ean": "42522001824",
        "generate_ean": false,
        "tracks": [
            {
                "id": 1686,
                "order": 0,
                "name": "Whispering Sands",
                "artists": [
                    {
                        "id": 2526,
                        "order": 0,
                        "artist": 346,
                        "kind": "main"
                    }
                ],
                "ISRC": "DEUD42323897",
                "generate_isrc": false,
                "genre": 8,
                "subgenre": 165,
                "mix_name": "",
                "resource": "",
                "mp3_resource": "",
                "album_only": false,
                "explicit_content": false,
                "track_lenght": "00:00:45",
                "track_data_complete": true,
                "track_ready_for_accounting": false,
                "track_accounting_data_editable": true,
                "spotify_id": null,
                "deezer_id": null,
                "qc_passed": true,
                "qc_feedback": {},
                "edited_after_qc": false
            },
            {
                "id": 1687,
                "order": 1,
                "name": "Echo of the Ancients",
                "artists": [
                    {
                        "id": 2527,
                        "order": 0,
                        "artist": 346,
                        "kind": "main"
                    }
                ],
                "ISRC": "DEUD42323898",
                "generate_isrc": false,
                "genre": 8,
                "subgenre": 165,
                "mix_name": "Remix",
                "resource": "",
                "mp3_resource": "",
                "album_only": false,
                "explicit_content": false,
                "track_lenght": "00:00:56",
                "track_data_complete": true,
                "track_ready_for_accounting": false,
                "track_accounting_data_editable": true,
                "spotify_id": null,
                "deezer_id": null,
                "qc_passed": true,
                "qc_feedback": {},
                "edited_after_qc": false
            }
        ],
        "all_tracks_ready": true,
        "sub_user": null,
        "release_date_passed": true,
        "has_delivery_confirmations": false,
        "transferred": false,
        "qc_passed": true,
        "qc_feedback": {},
        "edited_after_qc": false
    },
    {
        "id": 3,
        "name": "Mystic Voyage",
        "release_version": "Remix",
        "language": "EN",
        "auto_detect_language": true,
        "label": {
            "id": 1,
            "name": "Harmonic Fusion Records"
        },
        "artists": [
            {
                "id": 1622,
                "order": 0,
                "artist": {
                    "id": 348,
                    "name": "Iris Fugue"
                },
                "kind": "main"
            }
        ],
        "publisher": "Harmonic Fusion Records",
        "status": "distributed",
        "publisher_year": "2023",
        "copyright_holder": "Harmonic Fusion Records",
        "copyright_holder_year": "2023",
        "genre": 8,
        "subgenre": 68,
        "kind": "single",
        "catalogue_number": "CTQ011348",
        "notes": "",
        "artwork": ReleaseThree,
        "is_new_release": 0,
        "official_date": "2023-08-14",
        "original_date": "2023-08-14",
        "exclusive_shop": null,
        "territory": "worldwide",
        "countries": [],
        "backcatalog": true,
        "ean": "42003393487",
        "generate_ean": false,
        "tracks": [
            {
                "id": 1690,
                "order": 0,
                "name": "Shadow's Serenity",
                "artists": [
                    {
                        "id": 2530,
                        "order": 0,
                        "artist": 348,
                        "kind": "main"
                    }
                ],
                "ISRC": "DEUD42301690",
                "generate_isrc": true,
                "genre": 8,
                "subgenre": 68,
                "mix_name": "Remix",
                "resource": "",
                "mp3_resource": "",
                "album_only": false,
                "explicit_content": false,
                "track_lenght": "00:05:54",
                "track_data_complete": true,
                "track_ready_for_accounting": false,
                "track_accounting_data_editable": true,
                "spotify_id": null,
                "deezer_id": null,
                "qc_passed": true,
                "qc_feedback": {},
                "edited_after_qc": false
            },
            {
                "id": 1691,
                "order": 1,
                "name": "Stellar Drift",
                "artists": [
                    {
                        "id": 2531,
                        "order": 0,
                        "artist": 348,
                        "kind": "main"
                    }
                ],
                "ISRC": "DEUD42301691",
                "generate_isrc": true,
                "genre": 8,
                "subgenre": 68,
                "mix_name": "Remix",
                "resource": "",
                "mp3_resource": "",
                "album_only": false,
                "explicit_content": false,
                "track_lenght": "00:05:54",
                "track_data_complete": true,
                "track_ready_for_accounting": false,
                "track_accounting_data_editable": true,
                "spotify_id": null,
                "deezer_id": null,
                "qc_passed": true,
                "qc_feedback": {},
                "edited_after_qc": false
            }
        ],
        "all_tracks_ready": true,
        "sub_user": null,
        "release_date_passed": true,
        "has_delivery_confirmations": false,
        "transferred": false,
        "qc_passed": true,
        "qc_feedback": {},
        "edited_after_qc": false
    },
    {
        "id": 4,
        "name": "Rising Rhapsody",
        "release_version": "Remix",
        "language": "EN",
        "auto_detect_language": true,
        "label": {
            "id": 1,
            "name": "Harmonic Fusion Records"
        },
        "artists": [
            {
                "id": 1001,
                "order": 0,
                "artist": {
                    "id": 2,
                    "name": "Nadia Tune"
                },
                "kind": "main"
            }
        ],
        "publisher": "Harmonic Fusion Records",
        "status": "offline",
        "publisher_year": "2023",
        "copyright_holder": "Harmonic Fusion Records",
        "copyright_holder_year": "2023",
        "genre": 8,
        "subgenre": 154,
        "kind": "single",
        "catalogue_number": "JXC609445",        
        "notes": "",
        "artwork": ReleaseFour,
        "is_new_release": 1,
        "official_date": "2023-10-25",
        "original_date": "2023-10-25",
        "exclusive_shop": null,
        "territory": "worldwide",
        "countries": [],
        "backcatalog": false,
        "ean": "42773768108",
        "generate_ean": true,
        "tracks": [
            {
                "id": 1327,
                "order": 0,
                "name": "Galactic Rhapsody",
                "artists": [
                    {
                        "id": 2274,
                        "order": 0,
                        "artist": 2,
                        "kind": "main"
                    }
                ],
                "ISRC": "DEUD42301327",
                "generate_isrc": true,
                "genre": 8,
                "subgenre": 207,
                "mix_name": "",
                "resource": "",
                "mp3_resource": "",
                "album_only": false,
                "explicit_content": false,
                "track_lenght": "00:05:54",
                "track_data_complete": true,
                "track_ready_for_accounting": false,
                "track_accounting_data_editable": true,
                "spotify_id": null,
                "deezer_id": null,
                "qc_passed": false,
                "qc_feedback": {},
                "edited_after_qc": false
            },
            {
                "id": 1327,
                "order": 0,
                "name": "Whisper in the Wind",
                "artists": [
                    {
                        "id": 2274,
                        "order": 0,
                        "artist": 2,
                        "kind": "main"
                    }
                ],
                "ISRC": "DEUD42301327",
                "generate_isrc": true,
                "genre": 8,
                "subgenre": 207,
                "mix_name": "Remix",
                "resource": "",
                "mp3_resource": "",
                "album_only": false,
                "explicit_content": false,
                "track_lenght": "00:05:54",
                "track_data_complete": true,
                "track_ready_for_accounting": false,
                "track_accounting_data_editable": true,
                "spotify_id": null,
                "deezer_id": null,
                "qc_passed": false,
                "qc_feedback": {},
                "edited_after_qc": false
            },
            {
                "id": 1327,
                "order": 0,
                "name": "Morning Symphony",
                "artists": [
                    {
                        "id": 2274,
                        "order": 0,
                        "artist": 2,
                        "kind": "main"
                    }
                ],
                "ISRC": "DEUD42301327",
                "generate_isrc": true,
                "genre": 8,
                "subgenre": 207,
                "mix_name": "",
                "resource": "",
                "mp3_resource": "",
                "album_only": false,
                "explicit_content": false,
                "track_lenght": "00:05:54",
                "track_data_complete": true,
                "track_ready_for_accounting": false,
                "track_accounting_data_editable": true,
                "spotify_id": null,
                "deezer_id": null,
                "qc_passed": false,
                "qc_feedback": {},
                "edited_after_qc": false
            }
        ],
        "all_tracks_ready": true,
        "sub_user": null,
        "release_date_passed": true,
        "has_delivery_confirmations": false,
        "transferred": false,
        "qc_passed": false,
        "qc_feedback": {},
        "edited_after_qc": false
    },
    {
        "id": 5,
        "name": "Echoing Paradise",
        "release_version": "",
        "language": "EN",
        "auto_detect_language": true,
        "label": {
            "id": 51,
            "name": "Lyrical Landslide Records"
        },
        "artists": [
            {
                "id": 1623,
                "order": 0,
                "artist": {
                    "id": 347,
                    "name": "Piper Requiem"
                },
                "kind": "main"
            }
        ],
        "publisher": "Lyrical Landslide Records",
        "status": "distributed",
        "publisher_year": "2021",
        "copyright_holder": "Lyrical Landslide Records",
        "copyright_holder_year": "2021",
        "genre": 8,
        "subgenre": 166,
        "kind": "single",
        "catalogue_number": "BLR031",
        "notes": "Piper Requiem is a creative jack-of-all-trades and makes his debut in Lyrical Landslide Records with his highly anticipated track \"Twilight Echo\"!\n\n",
        "artwork": ReleaseFive,
        "is_new_release": 0,
        "official_date": "2021-11-26",
        "original_date": "2021-11-26",
        "exclusive_shop": null,
        "territory": "worldwide",
        "countries": [],
        "backcatalog": true,
        "ean": "42828938848",
        "generate_ean": false,
        "tracks": [
            {
                "id": 1688,
                "order": 0,
                "name": "Twilight Echo",
                "artists": [
                    {
                        "id": 2532,
                        "order": 0,
                        "artist": 347,
                        "kind": "main"
                    }
                ],
                "ISRC": "NL4WA2000066",
                "generate_isrc": false,
                "genre": 8,
                "subgenre": 166,
                "mix_name": "",
                "resource": "",
                "mp3_resource": "",
                "album_only": false,
                "explicit_content": false,
                "track_lenght": "00:00:45",
                "track_data_complete": true,
                "track_ready_for_accounting": false,
                "track_accounting_data_editable": true,
                "spotify_id": null,
                "deezer_id": null,
                "qc_passed": true,
                "qc_feedback": {},
                "edited_after_qc": false
            },
        ],
        "all_tracks_ready": true,
        "sub_user": null,
        "release_date_passed": true,
        "has_delivery_confirmations": false,
        "transferred": false,
        "qc_passed": true,
        "qc_feedback": {},
        "edited_after_qc": false
    },
]
export default mockReleaseDetailsData;